export default __webpack_public_path__ + "static/media/instagram_icon.a0eb6f9f.png";